// @flow
import {endpoints} from '../../../endpoints'

export async function fetchApiIndex(): Promise<ApiIndex<MapApi>> {
  const response = await fetch(endpoints.map, {
    headers: {
      'content-type': 'application/json; version=2.0',
      'Accept': 'application/json; version=2.0',
    },
  })
  if (response.status === 200) {
    return await response.json()
  } else {
    throw new Error(await response.text())
  }
}